export const homePosition = "0% 0%";
export const landingPosition = "-70% -70%";
export const aboutMePosition = "-70% 40%";
export const skillsPosition = "40%";
export const contactPosition = "70% -70%";
